import React, { PureComponent } from 'react';

class ErrorsView extends PureComponent {
  render() {
    const {
      errors,
      closeError,
    } = this.props;

    return (
      <div className="errors-container">

        {errors.map((error, i)=>(
          <div className="error-item" key={i}>
            {error.message}
            <a
              href="#"
              className="close"
              onClick={e=>{
                e.preventDefault();
                closeError(i);
              }}
            ><i className="fi-x size-18"></i></a>
          </div>
        ))}
      </div>
    )
  }
}

export default ErrorsView;



// WEBPACK FOOTER //
// ./src/app/modules/Errors/Errors.view.js